import type { Duration } from "../../google/protobuf/duration.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseDuration = (): Duration => {
  return {
    seconds: 0,
    nanos: 0,
  };
};

export const decodeDuration = (reader: Reader, length: number): Duration => {
  const end = reader.pos + length;
  const message = createBaseDuration();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.seconds = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.nanos = reader.int32();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeDuration = (writer: Writer, message: Duration): Writer => {
  writer.uint32(8).int64(message.seconds);
  writer.uint32(16).int32(message.nanos);

  return writer;
};
